<template>
    <div class="row" @mouseleave="handleMouseLeave">
        <div class="col-3 d-none d-xl-flex" />
        <div class="col-12 col-xl-6">
           
            <div class="m-3 mt-3 mt-md-0 m-lg-3 m-xl-5">
                <div class="row" style="background-color: white; border-radius: 8px !important;border :1px solid #121212;">
                    <div class="col-12">
                        <div class="row" style="display: flex;">
                        
                            <div class="col-11 text-left">
                                <input ref="searchInput" type="text" class="form-control font-size-16 text-dark font-weight-bold" 
                                    @keyup.enter="handleEnterKey"
                                    v-model="searchKeyword" 
                                    placeholder="Chercher un produit" 
                                    style=" border-color: transparent !important; height:52px !important;" inputmode="search">
                            </div>

                            <div class="col-1 d-flex align-items-center justify-content-center text-right">
                                <img @click="handleEnterKey"  style="cursor:pointer" src="@/assets/images/search.png" width="24px" height="24px" >
                            </div>
                        </div>
                    </div>
                </div>   
    
                <div class="row mt-3" >
                    <div :class=" currentUser ? 'col-12' : 'col-6' " >
                        <span class="mt-3 font-weight-bold text-secondary">Dernières recherches : </span> 
                    
                        <span v-for="(lastKeyword, index) in lastSearchKeywords" @click="searchKeyword=lastKeyword" style="cursor:pointer" class="mr-2 text-secondary" :key="index" >
                            {{ lastKeyword + ', ' }}
                        </span>
                        <span v-if="lastSearchKeywords.length" class="text-dark" style="letter-spacing:2px;"> ...</span>

                       

                    </div>

                    <div v-if="!currentUser" class="col-6 text-right" >
                        <a class="text-right font-weight-bold text-dark" href="/login"><u> se connecter </u></a>
                    </div>

                </div>
           
            </div>
            

        </div>
    </div>

</template>


<script >
import UsersApi from "@/services/users-api";
import store from '@/state/store'



export default ({
    name: "SearchMenu",
    components: {
        
    },
    props: {
        showSearch: Boolean,
        
    },
    mounted() {
        this.findLastSearches();
    },

    computed: {

        currentUser() {
            return store.getters['auth/currentUser'];
        },

    },
    data() {
        return {
            searchKeyword: null,
            lastSearchKeywords: []
        }
    },
    methods: {

        handleMouseLeave() {
            this.$emit('close');
        },

        findLastSearches() {

            if (!this.currentUser) {
                return;
            }

            UsersApi.findLastSearches()
                .then((result) => {
                    this.lastSearchKeywords = result;
                }
            );
        },

        handleEnterKey() {
            if (this.searchKeyword.trim() !== "") {
                this.$router.push({ path: '/catalogue/', query: { keyword: this.searchKeyword } })
                .then(() => {
                    this.$emit('close');
                })
                .catch(() => {
                    
                }); 
            }
        },
    },

    watch :{

        showSearch: function(){
          if(this.showSearch){
            this.$refs.searchInput.focus();
          }

          this.findLastSearches();
        }

    },
})
</script>
  
<style scoped>

</style>
  